import { Injectable } from '@angular/core';

/*
  Generated class for the CommonProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class CommonProvider {

	localVars: Array<string> = ['id_token', 'idtopic', 'idpartida', 'show_alert'];
	months: Array<string> = [
		"January", 
		"February", 
		"March", 
		"April", 
		"May", 
		"June",
		"July", 
		"August", 
		"September", 
		"October", 
		"November", 
		"December"
	];
	views: Object = {medalls: 'BadgesPage', thoughts: 'ThoughtsListPage', map: 'CalendarMapPage'};


	constructor() {
	}

	getLocalVars(){
		return this.localVars;
	}

	clearPlanVars(){
		window.localStorage.removeItem('idpartida');
		window.localStorage.removeItem('idtopic');
	}

	clearLocalVars(){
	  for(var i=0;i<this.localVars.length;i++){
	    if (window.localStorage.getItem(this.localVars[i])){
	      window.localStorage.removeItem(this.localVars[i]);
	    }
	  }
	}

	getMonths(){
		return this.months;
	}

	getViews(){
		return this.views;
	}


}



// WEBPACK FOOTER //
// ./src/providers/common/common.ts